export const getChablisData = () => ({
  name: "Chablis",
  region: "Bourgogne",
  country: "France",
  description: "Chablis est la région la plus septentrionale de la Bourgogne, produisant des vins blancs de Chardonnay d'une pureté et d'une minéralité exceptionnelles.",
  type: "subregion",
  area: "5,500 ha",
  production: "300,000 hectolitres",
  mapAreas: [
    { region: "Chablis", x: 55, y: 55, color: "#4B164C", size: 5 }
  ],
  characteristics: {
    climate: "Climat continental tempéré, hivers froids, étés chauds",
    soil: "Sols de marnes kimméridgiennes, calcaires",
    viticulture: "Viticulture traditionnelle, rendements limités, vendanges manuelles"
  },
  wineStyles: {
    white: "Vins blancs secs et minéraux, avec des notes de pierre à fusil et d'agrumes"
  },
  history: "Chablis produit des vins depuis l'époque romaine. Les moines cisterciens ont développé la viticulture au Moyen Âge. L'appellation est reconnue depuis 1938.",
  foodPairing: "Fruits de mer, poissons, volailles, fromages de chèvre",
  grapeVarieties: [
    {
      name: "Chardonnay",
      percentage: "100%",
      description: "Cépage unique de Chablis, produisant des vins blancs d'une pureté exceptionnelle",
      characteristics: "Sec, minéral, acidité vive, notes de pierre à fusil et d'agrumes",
      wineStyles: "Sec, léger, minéral"
    }
  ]
}); 